import React from "react";
import { useDispatch } from "react-redux";
import { useMsal } from "@azure/msal-react";
import { SkyDialog, SkyButton } from "@skypointcloud/skypoint-ui";
import { clearTokens } from "../../store/slices/authSlice";

interface ErrorPageProps {
  show: boolean;
  message?: string;
  errorCode?: string;
  title?: string;
}

const ErrorPage = ({ show, message, errorCode, title }: ErrorPageProps): React.ReactElement => {
  const { instance } = useMsal();
  const dispatch = useDispatch();

  const backToLogin = (): void => {
    dispatch(clearTokens());
    instance.logoutRedirect().catch((error) => {
      console.error("Logout failed:", error);
    });
  };

  return (
    <SkyDialog
      open={show}
      onOpenChange={() => {}}
      title={title || "Error occurs!"}
    >
      <div className="mb-[15px]">
        {errorCode && <b className="text-fg-danger">Error Code: {errorCode}</b>}
      </div>
      <div className="mb-[15px]">
        <b>Message</b>
        <p>{message}</p>
      </div>
      <div className="mb-[15px]">
        <SkyButton
          appearance="primary"
          onClick={backToLogin}
        >
          Go to Login
        </SkyButton>
      </div>
    </SkyDialog>
  );
};

export default ErrorPage;
